export default [
	{  // 【官网首页】-【Banner】
		path: 'website/home/banner',
		name: 'm_home_banner',
		meta: {
			title: '【中文】首页Banner'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/home/home_banner_list')
	},{  // 【官网首页】-【Banner】-英文
		path: 'website/home/banner/en',
		name: 'm_home_banner_en',
		meta: {
			title: '【英文】首页Banner'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/home/home_banner_list')
	}, {  // 【官网首页】-【集团简介】
		path: 'website/home/image',
		name: 'm_home_image',
		meta: {
			title: '【中文】首页模块图片'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/home/home_image')
	}, {  // 【官网首页】-【集团简介】
		path: 'website/home/image/en',
		name: 'm_home_image_en',
		meta: {
			title: '【英文】首页模块图片'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/home/home_image')
	}, {  // 【官网首页】-【集团简介】
		path: 'website/home/contact',
		name: 'm_home_contact',
		meta: {
			title: '【中文】首页联系方式'
		},
		props: {languageType:1},
		component: () => import('@/pages/website/home/home_contact')
	}, {  // 【官网首页】-【集团简介】
		path: 'website/home/contact/en',
		name: 'm_home_contact_en',
		meta: {
			title: '【英文】首页联系方式'
		},
		props: {languageType:2},
		component: () => import('@/pages/website/home/home_contact')
	}
];